import { render, staticRenderFns } from "./operation.vue?vue&type=template&id=2a283128&"
import script from "./operation.vue?vue&type=script&lang=js&"
export * from "./operation.vue?vue&type=script&lang=js&"
import style0 from "./operation.vue?vue&type=style&index=0&id=2a283128&prod&lang=less&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports